import './styles/InvitationBanner.css';

interface InvitationBannerProps {
  gameName: string;
  host: string;
  playerCount: number;
  onJoin: () => void;
}

const InvitationBanner: React.FC<InvitationBannerProps> = ({
  gameName,
  host,
  playerCount,
  onJoin,
}) => (
  <div className="invite-banner">
    <span className="invite-banner__tag">You're invited! 🎉</span>
    <h4 className="invite-banner__title">{gameName}</h4>
    <p className="invite-banner__sub">Hosted by {host} · {playerCount} players</p>
    <button className="invite-banner__btn" onClick={onJoin}>Join Now</button>
  </div>
);

export default InvitationBanner;
